module.exports = __webpack_public_path__ + "static/media/sidebar-4.1f6609d4.jpg";